(function () {
  'use strict';

  function init() {
    var bar = document.querySelector('[data-sticky-atc-bar]');
    if (!bar) return;

    var atcButton = document.getElementById('myAddtocart');
    if (!atcButton) {
      setTimeout(function () {
        var btn = document.getElementById('myAddtocart');
        if (btn) setup(bar, btn);
      }, 1000);
      return;
    }

    setup(bar, atcButton);
  }

  function getProductData() {
    var scripts = document.querySelectorAll('script[data-section-data]');
    for (var i = 0; i < scripts.length; i++) {
      try {
        var data = JSON.parse(scripts[i].textContent);
        if (data.product) return data.product;
      } catch (e) {}
    }
    return null;
  }

  function buildDrawer(product) {
    // Find the size option
    var sizeOptionIndex = -1;
    for (var i = 0; i < product.options.length; i++) {
      if (product.options[i].toLowerCase() === 'size') {
        sizeOptionIndex = i;
        break;
      }
    }
    if (sizeOptionIndex === -1) return null;

    // Build size-to-variant map
    var sizeKey = 'option' + (sizeOptionIndex + 1);
    var sizes = [];
    var seen = {};
    product.variants.forEach(function (v) {
      var size = v[sizeKey];
      if (!seen[size]) {
        seen[size] = true;
        // A size is available if ANY variant with that size is available
        var available = product.variants.some(function (vv) {
          return vv[sizeKey] === size && vv.available;
        });
        sizes.push({ name: size, available: available });
      }
    });

    // Create overlay
    var overlay = document.createElement('div');
    overlay.className = 'sticky-drawer-overlay';

    // Create drawer
    var drawer = document.createElement('div');
    drawer.className = 'sticky-drawer';

    // Close button
    var closeBtn = document.createElement('button');
    closeBtn.className = 'sticky-drawer__close';
    closeBtn.setAttribute('aria-label', 'Close');
    closeBtn.innerHTML = '&times;';
    drawer.appendChild(closeBtn);

    // Sizes label
    var label = document.createElement('p');
    label.className = 'sticky-drawer__label';
    label.textContent = 'Select a Size';
    drawer.appendChild(label);

    // Size buttons row
    var row = document.createElement('div');
    row.className = 'sticky-drawer__sizes';
    sizes.forEach(function (s) {
      var btn = document.createElement('button');
      btn.className = 'sticky-drawer__size';
      btn.textContent = s.name;
      btn.setAttribute('data-size', s.name);
      if (!s.available) {
        btn.classList.add('sticky-drawer__size--sold-out');
        btn.disabled = true;
      }
      row.appendChild(btn);
    });
    drawer.appendChild(row);

    // Add to Cart button
    var atcBtn = document.createElement('button');
    atcBtn.className = 'sticky-drawer__atc';
    atcBtn.textContent = 'Add to Cart';
    atcBtn.disabled = true;
    drawer.appendChild(atcBtn);

    document.body.appendChild(overlay);
    document.body.appendChild(drawer);

    return {
      overlay: overlay,
      drawer: drawer,
      closeBtn: closeBtn,
      sizeRow: row,
      atcBtn: atcBtn,
      product: product,
      sizeOptionIndex: sizeOptionIndex,
      selectedSize: null
    };
  }

  function openDrawer(state) {
    state.overlay.classList.add('sticky-drawer-overlay--visible');
    state.drawer.classList.add('sticky-drawer--visible');
  }

  function closeDrawer(state) {
    state.overlay.classList.remove('sticky-drawer-overlay--visible');
    state.drawer.classList.remove('sticky-drawer--visible');
  }

  function findVariant(product, sizeOptionIndex, sizeName) {
    var sizeKey = 'option' + (sizeOptionIndex + 1);
    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i][sizeKey] === sizeName && product.variants[i].available) {
        return product.variants[i];
      }
    }
    return null;
  }

  function addToCart(variantId, callback) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Add to cart failed');
        return res.json();
      })
      .then(function () { callback(null); })
      .catch(function (err) { callback(err); });
  }

  function setup(bar, atcButton) {
    var stickyButton = bar.querySelector('[data-sticky-atc-button]');
    var hasBeenShown = false;

    // IntersectionObserver: show bar when native ATC scrolls off top
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) {
          var rect = atcButton.getBoundingClientRect();
          if (rect.bottom < 0) {
            if (!hasBeenShown) {
              bar.style.display = '';
              bar.offsetHeight;
              hasBeenShown = true;
            }
            bar.classList.add('sticky-atc-bar--visible');
          } else {
            bar.classList.remove('sticky-atc-bar--visible');
          }
        } else {
          bar.classList.remove('sticky-atc-bar--visible');
        }
      });
    }, { threshold: 0 });

    observer.observe(atcButton);

    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(function () {
          var rect = atcButton.getBoundingClientRect();
          if (rect.bottom < 0) {
            if (!hasBeenShown) {
              bar.style.display = '';
              bar.offsetHeight;
              hasBeenShown = true;
            }
            bar.classList.add('sticky-atc-bar--visible');
          } else {
            bar.classList.remove('sticky-atc-bar--visible');
          }
          ticking = false;
        });
        ticking = true;
      }
    });

    // Build drawer from product data
    var product = getProductData();
    if (!product) return;

    var state = buildDrawer(product);
    if (!state) {
      // No size option — fall back to submitting the form directly
      stickyButton.addEventListener('click', function () {
        atcButton.click();
      });
      return;
    }

    // Sticky bar button opens drawer
    stickyButton.addEventListener('click', function () {
      openDrawer(state);
    });

    // Close drawer
    state.closeBtn.addEventListener('click', function () {
      closeDrawer(state);
    });
    state.overlay.addEventListener('click', function () {
      closeDrawer(state);
    });

    // Size selection
    state.sizeRow.addEventListener('click', function (e) {
      var btn = e.target.closest('.sticky-drawer__size');
      if (!btn || btn.disabled) return;

      // Update active state
      state.sizeRow.querySelectorAll('.sticky-drawer__size').forEach(function (b) {
        b.classList.remove('sticky-drawer__size--active');
      });
      btn.classList.add('sticky-drawer__size--active');
      state.selectedSize = btn.getAttribute('data-size');

      // Enable ATC
      state.atcBtn.disabled = false;
    });

    // Drawer ATC
    state.atcBtn.addEventListener('click', function () {
      if (!state.selectedSize || state.atcBtn.disabled) return;

      var variant = findVariant(state.product, state.sizeOptionIndex, state.selectedSize);
      if (!variant) return;

      state.atcBtn.disabled = true;
      state.atcBtn.textContent = 'Adding...';

      addToCart(variant.id, function (err) {
        if (err) {
          state.atcBtn.textContent = 'Try Again';
          state.atcBtn.disabled = false;
          return;
        }

        state.atcBtn.textContent = 'Added!';
        closeDrawer(state);

        // Open the theme's cart drawer
        if (window.PXUTheme && window.PXUTheme.jsAjaxCart) {
          window.PXUTheme.jsAjaxCart.updateView();
          window.PXUTheme.jsAjaxCart.showDrawer();
        }

        // Reset drawer state after close
        setTimeout(function () {
          state.atcBtn.textContent = 'Add to Cart';
          state.atcBtn.disabled = true;
          state.selectedSize = null;
          state.sizeRow.querySelectorAll('.sticky-drawer__size').forEach(function (b) {
            b.classList.remove('sticky-drawer__size--active');
          });
        }, 500);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
